import { Navigate, Outlet } from 'react-router-dom';

import useSystemFeatures from '../hooks/system/useSystemFeatures';
import LoadingOverlay from '../components/Loading/LoadingOverlay';

interface Props {
  /** Código de `SystemFeatureCode` que debe estar habilitado en el plan. */
  feature: string;
  /** A dónde redirigir si el feature está apagado. */
  redirectTo?: string;
}

/**
 * Bloquea un grupo de rutas si su funcionalidad de plan no está activa.
 * Se anida dentro de `ProtectedRouteV2` (primero autenticación, luego feature).
 */
const FeatureProtectedRoute: React.FC<Props> = ({
  feature,
  redirectTo = '/dashboard/general',
}) => {
  const { loaded, isEnabled } = useSystemFeatures();

  if (!loaded) {
    return <LoadingOverlay />;
  }

  return isEnabled(feature) ? <Outlet /> : <Navigate to={redirectTo} replace />;
};

export default FeatureProtectedRoute;
